var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "my-account-container" },
    [
      _vm.memberPortalActive
        ? [
            _c(
              "b-dropdown",
              {
                staticClass: "nav-link portal",
                attrs: {
                  text: "My Account",
                  title: "My Account",
                  "data-cy": "my-portal-link",
                  right: "",
                  "no-caret": "",
                  variant: "link",
                },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "nav-link-button-inner",
                    attrs: { slot: "button-content" },
                    slot: "button-content",
                  },
                  [
                    _c("page-top-svg-icons", { attrs: { name: "PortalIcon" } }),
                    _vm._v(" "),
                    _c("span", { staticClass: "nav-label" }, [
                      _vm._v("My Portal"),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-dropdown-item",
                  {
                    attrs: {
                      to: `/user/${_vm.userId}`,
                      title: `${_vm.fullname} [ID: ${_vm.userId}]`,
                      "data-cy": "member-portal-link",
                    },
                  },
                  [_vm._v("\n        My Portal\n      ")]
                ),
                _vm._v(" "),
                _c("user-logout", {
                  staticClass: "dropdown-item",
                  attrs: { "in-dropdown": "" },
                }),
              ],
              1
            ),
          ]
        : [_c("user-logout", { staticClass: "logout" })],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }